document.addEventListener('DOMContentLoaded', () => {
  function initVideoHover() {
    document.querySelectorAll('product-card').forEach((card) => {
      const video = card.querySelector('video');
      if (!video) return;

      const mediaWrapper = card.querySelector('.media, [class*="media"]');
      if (!mediaWrapper) return;

      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.style.cssText = `
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 2;
      `;
      mediaWrapper.style.position = 'relative';
      mediaWrapper.appendChild(video);

      card.addEventListener('mouseenter', () => {
        video.play();
        video.style.opacity = '1';
      });

      card.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
        video.style.opacity = '0';
      });
    });
  }

  initVideoHover();

  // Re-init nếu có lazy load
  const observer = new MutationObserver(() => initVideoHover());
  observer.observe(document.body, { childList: true, subtree: true });
});
